import axios from 'axios';

import {getCookie} from '-/util/util';

let existingPing = false;
let pingCallbacks = [];

export const getCsrfToken = async(force = false) => {
    let cookie = getCookie('XSRF-TOKEN');

    if (force === true || !cookie) {
        if (existingPing) {
            return new Promise(resolve => {
                pingCallbacks.push(cookie => {
                    resolve(cookie);
                });
            });
        }

        existingPing = true;
        await axios.get('/api/ping');
        cookie = getCookie('XSRF-TOKEN');

        for (const pingCallback of pingCallbacks) {
            pingCallback(cookie);
        }

        pingCallbacks = [];
        existingPing = false;
    }

    return cookie;
};
